import type { ServerSuppliedWebUIConfig } from "~/models/dto";

import type { TypedAction } from "../../../generic/redux/TypedRedux";

import { CHECK_SESSION, SET_UI_CONFIG } from "./ConfigActionTypes";

interface SetUiConfigData {
	config: ServerSuppliedWebUIConfig;
}

export type SetUiConfig = SetUiConfigData & TypedAction<typeof SET_UI_CONFIG>;

export const setUiConfig = (config: ServerSuppliedWebUIConfig): SetUiConfig => ({
	type: SET_UI_CONFIG,
	config,
});

export type CheckSession = TypedAction<typeof CHECK_SESSION>;

export const checkSession = (): CheckSession => ({
	type: CHECK_SESSION,
});
